import {
  palette,
  navy,
  green,
  blue,
  gray,
  neutral,
  semantic,
  gradients,
  shadows,
  shadowColors,
  overlay,
  focusRing,
  spacing,
  borderRadius,
  typography,
  textStyles,
  breakpoints,
  transitions,
  zIndex,
  brand,
  layout,
} from './tokens';

/**
 * Tema do styled-components.
 *
 * COMPATIBILIDADE: todas as chaves consumidas pelas 79 páginas continuam
 * existindo; só os valores mudaram. As rampas (`navy`, `green`, `blue`, `gray`)
 * e as semânticas estendidas entram como adição.
 */
export const theme = {
  colors: {
    // ---- chaves legadas (valores novos) ----
    primary: palette.primary,
    primaryHover: palette.primaryHover,
    primaryActive: palette.primaryActive,

    secondary: palette.secondary,
    secondaryHover: palette.secondaryHover,

    accent: palette.accent,
    accentHover: palette.accentHover,

    success: palette.success,
    successHover: palette.successHover,

    warning: palette.warning,
    warningHover: palette.warningHover,

    error: palette.error,
    errorHover: palette.errorHover,

    textPrimary: palette.textPrimary,
    textSecondary: palette.textSecondary,
    textDisabled: palette.textDisabled,

    neutral,

    bgPrimary: palette.bgPrimary,
    bgSecondary: palette.bgSecondary,
    bgTertiary: palette.bgTertiary,

    border: palette.border,
    borderSecondary: palette.borderSecondary,

    gradientPrimary: gradients.primary,
    gradientSecondary: gradients.secondary,
    gradientSuccess: gradients.success,

    ...shadowColors,

    // ---- adições ----
    navy,
    green,
    blue,
    gray,

    link: palette.link,
    linkHover: palette.linkHover,
    linkActive: palette.linkActive,

    successBg: semantic.successBg,
    successBorder: semantic.successBorder,
    successText: semantic.successText,
    successTextOnBg: semantic.successTextOnBg,

    warningBg: semantic.warningBg,
    warningBorder: semantic.warningBorder,
    warningTextOnBg: semantic.warningTextOnBg,

    errorBg: semantic.errorBg,
    errorBorder: semantic.errorBorder,
    errorTextOnBg: semantic.errorTextOnBg,

    info: semantic.info,
    infoBg: semantic.infoBg,
    infoBorder: semantic.infoBorder,
    infoTextOnBg: semantic.infoTextOnBg,

    sidebarBg: palette.sidebarBg,
    sidebarBgActive: palette.sidebarBgActive,
    sidebarText: palette.sidebarText,
    sidebarTextActive: palette.sidebarTextActive,
    sidebarGroupTitle: palette.sidebarGroupTitle,
    sidebarAccent: palette.sidebarAccent,

    overlay,
  },
  spacing,
  borderRadius,
  shadows,
  focusRing,
  typography,
  textStyles,
  breakpoints,
  transitions,
  zIndex,
  brand,
  layout,
} as const;

export type Theme = typeof theme;
